module.exports = __webpack_public_path__ + "static/media/Sherlog_Final_001.03f87c2b.png";